var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['progress', _vm.progressStatus]})
}
var staticRenderFns = []

export { render, staticRenderFns }